import React, { useState } from "react";
//import Modal from "react-bootstrap/Modal";
import Searchprofilehub from "./../management/searchprofilehub";
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
const ModalSearchhub = ({ header, onSelect, isOpen, onCancel, search = '', list }) => {

    function handleUpdateData(value) {
      
        onSelect(value);

    }
    //console.log("listlist",list)
    return (
        <>

            <Modal
                 className="modal-dialog modal-md"
                 isOpen={isOpen}
                 toggle={onCancel}
                 centered
                 
            >
                <ModalHeader >

                    ค้นหา {header}

                </ModalHeader>
                <ModalBody>
                    <Searchprofilehub
                        list={list}
                        search={search}
                        updateData={handleUpdateData}
                    />

                </ModalBody>
                <ModalFooter>
                    <Button
                        type="primary"
                        variant="danger"
                        onClick={onCancel}
                    >
                        Close
            </Button>
                </ModalFooter>
            </Modal>

        </>
    );
};

export default ModalSearchhub;
